import { Icon } from '@rbilabs/universal-components';

import Currency from 'components/currency';
import { isHydrationOrDehydrationInProgress } from 'hooks/use-cart-hydration.ts';
import { useCartContext } from 'state/cart';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

import { Container, Header, LineItem, TextDetails, Title, TitleContainer } from './styled';

const PriceMismatchInternalOnly = () => {
  const enableInternalDiagnosticTools = useFlag(LaunchDarklyFlag.ENABLE_INTERNAL_DIAGNOSTIC_TOOLS);

  const {
    requestedAmountCents,
    serverOrder,
    priceOrderFailure,
    isOrderPricingRetryInProgress,
    isOrderPriceLoading,
  } = useCartContext();

  if (!enableInternalDiagnosticTools) {
    return null;
  }

  const subTotalCents = serverOrder?.cart.subTotalCents;
  const isPriceMismatch = subTotalCents && subTotalCents !== requestedAmountCents;
  const isPriceFailureFinal = priceOrderFailure && !isOrderPricingRetryInProgress;

  if (isOrderPriceLoading || isHydrationOrDehydrationInProgress) {
    return null;
  }

  if (!isPriceMismatch && !isPriceFailureFinal) {
    return null;
  }

  return (
    <Container>
      <Header>{t('forInternalUseOnly')}</Header>
      <LineItem>
        <TextDetails>RBI Order ID</TextDetails>
        <TextDetails>{serverOrder?.rbiOrderId}</TextDetails>
      </LineItem>
      <LineItem>
        <TextDetails>Status</TextDetails>
        <TextDetails>{serverOrder?.status}</TextDetails>
      </LineItem>
      {serverOrder?.delivery?.status && (
        <LineItem>
          <TextDetails>Delivery Status</TextDetails>
          <TextDetails>{serverOrder.delivery.status}</TextDetails>
        </LineItem>
      )}
      {isPriceMismatch && (
        <>
          <TitleContainer>
            <Icon variant="warning" color={primitive.$white} aria-hidden size="4" />
            <Title>{t('priceMismatchDetected')}</Title>
          </TitleContainer>
          <LineItem>
            <TextDetails>{t('requestedAmount')}</TextDetails>
            <Currency textProps={{ color: primitive.$white }} amount={requestedAmountCents} />
          </LineItem>
          <LineItem>
            <TextDetails>{t('subtotal')}</TextDetails>
            <Currency textProps={{ color: primitive.$white }} amount={subTotalCents} />
          </LineItem>
        </>
      )}
      {priceOrderFailure && (
        <>
          <TitleContainer>
            <Icon variant="warning" color={primitive.$white} aria-hidden size="4" />
            <Title>Pricing Error</Title>
          </TitleContainer>
          <LineItem>
            <TextDetails>Error Type</TextDetails>
            {serverOrder?.orderErrors?.orderInjectionErrors?.isStoreAvailabilityError && (
              <TextDetails>Store Availability Error</TextDetails>
            )}
            {serverOrder?.orderErrors?.orderInjectionErrors?.isTimeoutError && (
              <TextDetails>Timeout Error</TextDetails>
            )}
            {serverOrder?.orderErrors?.orderInjectionErrors?.isMenuError && (
              <TextDetails>Menu Error</TextDetails>
            )}
            {serverOrder?.orderErrors?.orderInjectionErrors?.isConfigurationError && (
              <TextDetails>Configuration Error</TextDetails>
            )}
            {serverOrder?.orderErrors?.orderInjectionErrors?.isUnknownError && (
              <TextDetails>Unknown Error</TextDetails>
            )}
          </LineItem>
        </>
      )}
    </Container>
  );
};

export default PriceMismatchInternalOnly;
